import React, {Component} from 'react';
import { Icon, Responsive, Container } from 'semantic-ui-react'
import './Header.sass';

import shLogoFull from 'assets/logos/sh_logo_full_horizontal.png';

class Header extends Component {

	render() {
		return (
			<nav className="nav ui sticky">
				<Container>
					<Responsive as={Icon} name="bars" onClick={this.props.onMenuClick}></Responsive>
					<a href="https://starterhacks.ca/">
						<img className="logo" src={shLogoFull} alt="StarterHacks Logo"/>
					</a>
				</Container>
			</nav>
		);
	}
}

export default Header;
